// FedRAMP R icon component
const FedRAMPIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="29"
    height="22"
    viewBox="0 0 29 22"
    fill="none"
  >
    <path
      d="M2.75475 0.930099C2.4642 0.924467 2.17547 0.976726 1.90552 1.0838C1.63557 1.19088 1.38986 1.35061 1.18284 1.55359C0.975832 1.75658 0.811695 1.99872 0.700091 2.26577C0.588487 2.53283 0.531669 2.8194 0.532981 3.10863V21.0704H5.15321V13.9251H10.9656V9.4285H5.15321V5.53105H22.3466C22.8327 5.57858 23.2837 5.80442 23.6117 6.16461C23.9398 6.5248 24.1215 6.9936 24.1215 7.47978C24.1215 7.96595 23.9398 8.43475 23.6117 8.79494C23.2837 9.15513 22.8327 9.38097 22.3466 9.4285H14.2841C13.8854 9.46456 13.5126 9.64067 13.2325 9.92533C12.9523 10.21 12.7831 10.5846 12.755 10.9821V21.0669H17.3717V13.9779H19.9257L23.6224 21.0681H28.7798L24.7038 13.2626C26.1025 12.7238 27.2671 11.714 27.995 10.4088C28.7229 9.10363 28.968 7.58577 28.6877 6.11932C28.4073 4.65286 27.6193 3.33064 26.4607 2.38273C25.3021 1.43481 23.8463 0.921205 22.3466 0.931271L2.75475 0.930099Z"
      fill="#1E1E1E"
    />
  </svg>
);

// Custom Document icon component
const DocumentIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 36 36"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.81802 2.81802C6.66193 1.97411 7.80653 1.5 9 1.5H22.5C22.8978 1.5 23.2794 1.65804 23.5607 1.93934L31.0607 9.43934C31.342 9.72064 31.5 10.1022 31.5 10.5V30C31.5 31.1935 31.0259 32.3381 30.182 33.182C29.3381 34.0259 28.1935 34.5 27 34.5H9C7.80653 34.5 6.66193 34.0259 5.81802 33.182C4.97411 32.3381 4.5 31.1935 4.5 30V6C4.5 4.80653 4.97411 3.66193 5.81802 2.81802ZM27.8787 10.5H24C23.6022 10.5 23.2206 10.342 22.9393 10.0607C22.658 9.77936 22.5 9.39782 22.5 9V5.12132L27.8787 10.5ZM19.5 4.5V9C19.5 10.1935 19.9741 11.3381 20.818 12.182C21.6619 13.0259 22.8065 13.5 24 13.5H28.5V30C28.5 30.3978 28.342 30.7794 28.0607 31.0607C27.7794 31.342 27.3978 31.5 27 31.5H9C8.60218 31.5 8.22064 31.342 7.93934 31.0607C7.65804 30.7794 7.5 30.3978 7.5 30V6C7.5 5.60217 7.65804 5.22064 7.93934 4.93934C8.22064 4.65804 8.60217 4.5 9 4.5H19.5Z"
      fill="#595959"
    />
  </svg>
);

// Custom Download icon component
const DownloadIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="14"
    viewBox="0 0 15 14"
    fill="none"
  >
    <path
      d="M7.56831 9.3252C7.58 9.34014 7.59494 9.35222 7.612 9.36053C7.62905 9.36884 7.64778 9.37316 7.66675 9.37316C7.68572 9.37316 7.70444 9.36884 7.7215 9.36053C7.73855 9.35222 7.75349 9.34014 7.76519 9.3252L9.51519 7.11113C9.57925 7.02988 9.52144 6.90957 9.41675 6.90957H8.25894V1.62207C8.25894 1.55332 8.20269 1.49707 8.13394 1.49707H7.19644C7.12769 1.49707 7.07144 1.55332 7.07144 1.62207V6.90801H5.91675C5.81206 6.90801 5.75425 7.02832 5.81831 7.10957L7.56831 9.3252ZM13.3855 8.77832H12.448C12.3792 8.77832 12.323 8.83457 12.323 8.90332V11.3096H3.0105V8.90332C3.0105 8.83457 2.95425 8.77832 2.8855 8.77832H1.948C1.87925 8.77832 1.823 8.83457 1.823 8.90332V11.9971C1.823 12.2736 2.04644 12.4971 2.323 12.4971H13.0105C13.2871 12.4971 13.5105 12.2736 13.5105 11.9971V8.90332C13.5105 8.83457 13.4542 8.77832 13.3855 8.77832Z"
      fill="#8C8C8C"
    />
  </svg>
);

const FileZipIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="36"
    height="36"
    viewBox="0 0 41 41"
    fill="none"
  >
    <path
      d="M27 32.5628C27 31.6424 26.2538 30.8962 25.3333 30.8962C24.4129 30.8962 23.6667 31.6424 23.6667 32.5628C23.6667 33.4833 24.4129 34.2295 25.3333 34.2295C26.2538 34.2295 27 33.4833 27 32.5628ZM2 30.8962V9.22949C2 7.90341 2.52716 6.63202 3.46484 5.69434C4.40253 4.75665 5.67392 4.22949 7 4.22949H13.5495L13.8604 4.23926C14.5806 4.28413 15.2835 4.48499 15.9209 4.82845C16.6495 5.22113 17.2706 5.78759 17.7259 6.47884H17.7243L19.0654 8.46289L19.0752 8.47917C19.2285 8.71198 19.4379 8.90315 19.6839 9.03418C19.9298 9.16509 20.2046 9.23212 20.4831 9.22949H33.6667C34.9927 9.22949 36.2641 9.75665 37.2018 10.6943C38.1395 11.632 38.6667 12.9034 38.6667 14.2295V30.8848L38.6569 31.2331C38.606 32.0433 38.3578 32.8307 37.9326 33.5264C37.4467 34.3215 36.7482 34.9658 35.916 35.3851L35.1673 33.8958L34.417 32.4082C34.6944 32.2684 34.9272 32.0531 35.0892 31.7881C35.251 31.5231 35.3355 31.218 35.3333 30.9076V14.2295C35.3333 13.7875 35.1576 13.3637 34.8451 13.0511C34.5715 12.7775 34.2127 12.6088 33.8311 12.571L33.6667 12.5628H20.4993V12.5612C19.6689 12.5665 18.8497 12.3673 18.1165 11.9769C17.3839 11.5867 16.7607 11.0195 16.3018 10.3281L14.9525 8.32943L14.9411 8.31315C14.7894 8.08289 14.5831 7.89391 14.3405 7.76302C14.1585 7.66496 13.9601 7.60134 13.7562 7.57585L13.5495 7.56283H7C6.55797 7.56283 6.13417 7.73855 5.82161 8.05111C5.50905 8.36367 5.33333 8.78746 5.33333 9.22949V30.8962C5.33333 31.3382 5.50905 31.762 5.82161 32.0745C6.13418 32.3871 6.55797 32.5628 7 32.5628H15.4993C16.4198 32.5628 17.166 33.309 17.166 34.2295C17.166 35.15 16.4198 35.8962 15.4993 35.8962H7C5.67392 35.8962 4.40252 35.369 3.46484 34.4313C2.52716 33.4936 2 32.2222 2 30.8962ZM35.916 35.3851C35.0941 35.7987 34.0921 35.4679 33.6781 34.6462C33.2639 33.8241 33.595 32.8224 34.417 32.4082L35.916 35.3851ZM23.6667 19.2295V17.5628C23.6667 16.6424 24.4129 15.8962 25.3333 15.8962C26.2538 15.8962 27 16.6424 27 17.5628V19.2295C27 20.15 26.2538 20.8962 25.3333 20.8962C24.4129 20.8962 23.6667 20.15 23.6667 19.2295ZM30.3333 32.5628C30.3333 35.3242 28.0948 37.5628 25.3333 37.5628C22.5719 37.5628 20.3333 35.3242 20.3333 32.5628C20.3333 30.3864 21.7255 28.5394 23.6667 27.8525V25.8962C23.6667 24.9757 24.4129 24.2295 25.3333 24.2295C26.2538 24.2295 27 24.9757 27 25.8962V27.8525C28.9411 28.5394 30.3333 30.3864 30.3333 32.5628Z"
      fill="#595959"
    />
  </svg>
);

export const iconMap = {
  fedramp: <FedRAMPIcon />,
  document: <DocumentIcon />,
  fileZip: <FileZipIcon />,
  download: <DownloadIcon />,
};

export const getIcon = (iconName) => {
  return iconMap[iconName] || null;
};
